import { SCRIPTS_PATH } from '~/services/endpoints';
import { createLoginURL} from '../services/keycloak';

// Gera uma string aleatória para PKCE
export const generateRandomString = () => {
  const array = new Uint32Array(28);
  crypto.getRandomValues(array);
  return Array.from(array, (dec) => ('0' + dec.toString(16)).slice(-2)).join('');
};

// Calcula o SHA-256 de uma string
const sha256 = async (plain: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return crypto.subtle.digest('SHA-256', data);
};

// Converte o hash para Base64 URL-Safe
const base64urlencode = (str: ArrayBuffer) => {
  const base64 = btoa(String.fromCharCode(...new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
  const end = base64.indexOf('=');
  return end === -1 ? base64 : base64.slice(0, end);
};


// Gera um desafio PKCE a partir do verificador
export const pkceChallengeFromVerifier = async (pkceCodeVerifier: string) => {
  const hashed = await sha256(pkceCodeVerifier);
  return base64urlencode(hashed);
};

// Armazena um novo verificador PKCE nos cookies
export const setNewPkceCodeVerifier = () => {
  const pkceCodeVerifier = generateRandomString();
  document.cookie = `pkceCodeVerifier=${pkceCodeVerifier}; path=/; secure; samesite=strict`;
  return pkceCodeVerifier;
};

// Redireciona para a página de login
export const redirectToLogin = async () => {
  const pkceCodeVerifier = setNewPkceCodeVerifier();
  localStorage.setItem("pkceCodeVerifier", pkceCodeVerifier);

  // Ensure clean redirect URL without OAuth parameters
  const cleanRedirectUri = `${window.location.origin}${SCRIPTS_PATH}`;

  const loginUrl = await createLoginURL(cleanRedirectUri, pkceCodeVerifier);

  // Redirect user to login URL
  window.location.href = loginUrl;
};

export const stripOauthParamsFromUrl = (url: string) => {
  const currentUrl = new URL(url);

  currentUrl.searchParams.delete('code');
  currentUrl.searchParams.delete('session_state');
  //currentUrl.searchParams.delete('iss');
  return currentUrl.toString();
};


export const setNewTokenCookie = (accessToken: string, refreshToken: string, expiresIn: string) => {
  const expirationDate = new Date();
  expirationDate.setHours(expirationDate.getHours() + 1);
  document.cookie = `access_token=${accessToken}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=strict`;
  document.cookie = `refresh_token=${refreshToken}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=strict`;
  document.cookie = `expires_in=${expiresIn}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=strict`;
};

export const setTokenInSessionStorage = (accessToken: string, refreshToken: string, expiresIn: string) => {
  sessionStorage.setItem('access_token', accessToken);
  sessionStorage.setItem('refresh_token', refreshToken);
  sessionStorage.setItem('expires_in', expiresIn);
};
